<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você confere todas as repostas que a startup submeteu as
              tarefas do batch. A data de submissão da resposta e a data da
              última atualização são exibidas abaixo de cada tarefa.
            </p>
          </div>
          <div class="col-12 text-right mb-3">
            <router-link
              :to="`/admin/batches/${$route.params.idBatch}/acompanhamento`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para o painel de
              acompanhamento do batch</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                Respostas para as tarefas do batch
                <span v-if="batch">
                  <span class="text-warning">{{ batch.name }}</span>
                  <router-link
                    :to="`/admin/batches/${batch.id}/acompanhamento`"
                  >
                    <i class="ml-2 fas fa-eye text-sm"></i>
                  </router-link>
                </span>
              </h3>
            </div>
            <div class="card-body vld-parent" ref="startup_container">
              <div class="row text-center">
                <div class="pt-3 pb-2 col-12">
                  <div class="card-profile-image">
                    <img
                      :src="getStartupLogoPath(startup.logo)"
                      class="card-image my-3"
                      alt="..."
                    />
                  </div>
                  <h2 class="card-title mb-0 mt-8">
                    <span class="text-orange">{{ startup.name }}</span>
                    <router-link
                      :to="`/admin/startups/${startup.user_id}/editar`"
                    >
                      <i class="ml-2 fas fa-eye text-sm"></i>
                    </router-link>
                  </h2>
                  <div class="h5 font-weight-300 mb-3">
                    <i class="ni ni-pin-3 mr-2"></i>{{ startup.city || "..." }},
                    {{ startup.state || "..." }}
                  </div>
                  <div class="col-12 text-center">
                    <span
                      class="bg-white text-dark rounded border px-2 py-1 font-weight-normal text-sm"
                      v-if="totalResponses && tasks.length"
                    >
                      Taxa de respostas:
                      <span class="text-warning font-weight-bold"
                        >{{
                          Math.round((totalResponses / tasks.length) * 100, 2)
                        }}%</span
                      >
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" v-if="tasks.length">
                <div class="col-12">
                  <p class="text-muted text-right text-sm mb-0">
                    <b class="font-weight-bold"
                      >{{ totalResponses }} respostas</b
                    >
                    de um total de
                    <b class="font-weight-bold">{{ tasks.length }} tarefas</b>
                    iniciadas no batch
                  </p>
                </div>
              </div>
              <hr class="mt-1 mb-3" />
              <div v-if="empty" class="text-warning text-center mt-4">
                Não há tarefas no batch
              </div>
              <div v-else class="row vld-parent" ref="tasks_container">
                <div class="col-12 text-right mb-3">
                  <base-button
                    type="link"
                    :custom="true"
                    @click="showAnswersAsTable = !showAnswersAsTable"
                    ><span
                      v-if="showAnswersAsTable"
                      title="Exibir todas as tarefas iniciadas até o momento no batch"
                      >Visualização completa</span
                    ><span
                      v-else
                      title="Exibir as tarefas iniciadas com respostas númericas e agrupadas por família"
                      >Visualização agrupada</span
                    ></base-button
                  >
                </div>
                <div class="col-12" v-if="showAnswersAsTable">
                  <task-family-table :tasks="tasks" />
                </div>
                <div class="col-12" v-else>
                  <div
                    class="col-12 mt-3"
                    v-for="task in tasks"
                    :key="'task_' + task.id"
                  >
                    <div class="card">
                      <div class="card-body pt-2 pb-2">
                        <div class="row">
                          <div class="col-lg-4 my-3">
                            <h4 class="heading-small text-muted mb-2">
                              Tarefa
                            </h4>
                            <div class="col-12 text-center">
                              <span
                                title="Ver tarefa"
                                class="task-card pb-1 mt-0"
                                @click="handleViewTask(task.id)"
                              >
                                <div class="mb-3 task-card-header">
                                  <i class="fas fa-clipboard-list"></i>
                                  <span :title="task.title">{{
                                    task.title
                                  }}</span>
                                </div>

                                <span class="float-right text-sm text-muted"
                                  ><i class="far fa-calendar-alt mr-1"></i> até
                                  {{ formatDate(task.deadline) }}</span
                                >
                              </span>
                            </div>
                          </div>
                          <div class="col-lg-8 my-3 ts-container-read-only">
                            <div class="col-12" v-if="task.responses[0]">
                              <div v-if="task.is_number">
                                <h4 class="heading-small mb-2 pl-1">
                                  Resposta da startup:
                                  <span
                                    class="text-md font-weight-bold bg-white rounded border ml-1 px-3 py-1"
                                    >{{ task.responses[0].answer_number }}</span
                                  >
                                </h4>
                                <h4 class="heading-small text-muted mb-2 pl-1">
                                  Comentários
                                </h4>
                              </div>
                              <h4 class="heading-small text-muted mb-2" v-else>
                                Resposta da startup
                              </h4>
                              <quill-editor
                                v-model="task.responses[0].answer_text"
                                :options="editorReadOnly"
                                disabled="disabled"
                              >
                              </quill-editor>
                              <div class="mt-2">
                                <div class="text-muted text-sm text-right">
                                  Respondido em:
                                  {{
                                    formatDate(
                                      task.responses[0].created_at,
                                      "L"
                                    )
                                  }}. Última atualização em:
                                  {{
                                    formatDate(
                                      task.responses[0].updated_at,
                                      "L"
                                    )
                                  }}
                                </div>
                              </div>
                            </div>
                            <div class="col-12" v-else>
                              <h4 class="heading-small text-muted mb-2">
                                Resposta da startup
                              </h4>
                              <badge type="warning mt-3"
                                >Ainda não respondeu</badge
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import TaskFamilyTable from "@/components/TaskFamilyTable";

import api from "@/services/api";

export default {
  name: "tasks_list",
  components: {
    quillEditor,
    TaskFamilyTable,
  },
  data() {
    return {
      batch: "",
      startup: {
        user_id: "",
        name: "",
        city: "",
        state: "",
        logo: "",
      },
      tasks: [],
      totalResponses: "",
      empty: "",
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble",
      },
      showAnswersAsTable: true,
    };
  },
  async mounted() {
    await this.loadBatch();
    await this.loadStartup();
    await this.loadTasks();
  },
  methods: {
    async loadBatch() {
      try {
        const { data: batch } = await api.get(
          `/batches/${this.$route.params.idBatch}`
        );
        if (!batch) throw new Error("Batch not found");
        this.batch = batch;
      } catch (e) {
        this.$toasted.error("Error ao carregar informações do batch");
        this.$router.push("/admin/batches");
      }
    },
    async loadStartup() {
      const loaderStartup = this.$loading.show({
        container: this.$refs.startup_container,
        width: 100,
        height: 100,
      });
      try {
        const { data: startup } = await api.get(
          `/adm/startups/${this.$route.params.idStartup}`
        );
        if (!startup) {
          this.$toasted.error("Startup não encontrada");
          this.$router.push(
            `/admin/batches/${this.$route.params.idBatch}/acompanhamento`
          );
          return;
        }
        this.startup = startup;
        loaderStartup.hide();
      } catch (e) {
        this.$toasted.error("Error ao carregar as informações da startup");
        this.$router.push(
          `/admin/batches/${this.$route.params.idBatch}/acompanhamento`
        );
      }
    },
    async loadTasks() {
      const loaderTasks = this.$loading.show({
        container: this.$refs.tasks_container,
        width: 100,
        height: 100,
      });
      try {
        const { data: tasks } = await api.get(
          `/batches/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}/tasks`
        );
        if (tasks.length) {
          let countResponses = 0;
          tasks.forEach((task) => {
            if (task.responses.length > 0) countResponses++;
          });
          this.tasks = tasks;
          this.totalResponses = countResponses;
        } else this.empty = true;
        loaderTasks.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as informações das tarefas"
        );
      }
    },
    getStartupLogoPath(logo) {
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!logo) return defaultLogoPath;
      return logo.url;
    },
    handleViewTask(taskId) {
      this.$router.push(
        `/admin/batches/${this.batch.id}/acompanhamento/tarefas/${taskId}/editar`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.task-card {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;

  &:hover {
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
  }

  > div {
    align-items: center;
    display: flex;
  }

  .task-card-header i {
    box-sizing: content-box;
    color: #5e72e4;
    vertical-align: middle;
    font-size: 1.5rem;
  }

  span {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-left: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}

.card-profile-image img {
  width: 150px;
  height: 150px;
  border-radius: 10%;
}
</style>
<style>
.ts-container-read-only .quill-editor .ql-container,
.ts-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 17rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
